var styleDataHash = "cdd74e27";
const injectCss = () => {
  var css = `._48Hg8,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.LGToq{color:var(--ricos-settings-text-color,#000);width:100%}[dir] .LGToq{background-color:#fff}.LGToq.QrOxm{color:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff))}@supports not (contain:inline-size){@media only screen and (max-width:640px){.LGToq{height:47px}}}@container (width < 640px){.LGToq{height:47px}}.LGToq .ZaLNc{align-items:center;display:grid;grid-auto-columns:max-content auto max-content;grid-auto-flow:column;height:40px;grid-gap:12px}[dir=ltr] .LGToq .ZaLNc,[dir=rtl] .LGToq .ZaLNc{padding-left:20px;padding-right:20px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.LGToq .ZaLNc.eeZ6w{grid-auto-columns:auto}}}@container (width < 640px){.LGToq .ZaLNc.eeZ6w{grid-auto-columns:auto}}.LGToq .ZaLNc .DPJl5{align-self:left}@supports not (contain:inline-size){@media only screen and (max-width:640px){.LGToq .ZaLNc .DPJl5{display:flex;width:100%}}}@container (width < 640px){.LGToq .ZaLNc .DPJl5{display:flex;width:100%}}.LGToq .ZaLNc .pp2un{display:grid;grid-auto-flow:row}.LGToq .ZaLNc .pp2un ._4b7jI{font-size:14px}.LGToq .ZaLNc .pp2un .jo2-B{color:#646464;font-size:12px}.LGToq .ZaLNc ._43UwN{align-self:right}.LGToq.QrOxm,.LGToq:active{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .LGToq.QrOxm,[dir] .LGToq:active{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.1)}.LGToq.QrOxm svg,.LGToq:active svg{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));fill:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .LGToq:hover{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.05);cursor:pointer}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_select_default = {
  "fontElementMap": "_48Hg8",
  "container": "LGToq",
  "selected": "QrOxm",
  "content": "ZaLNc",
  "content_mobile_alignCenter": "eeZ6w",
  "prefix": "DPJl5",
  "titleWrapper": "pp2un",
  "title": "_4b7jI",
  "subtitle": "jo2-B",
  "suffix": "_43UwN"
};
export {
  list_item_select_default as default,
  injectCss
};
//# sourceMappingURL=list-item-select-scss.js.map
